module.exports = __webpack_public_path__ + "static/media/logo.9a7ca8a1.svg";